import { render, staticRenderFns } from "./MainLedgerAccountCard.vue?vue&type=template&id=3b912034&scoped=true"
import script from "./MainLedgerAccountCard.vue?vue&type=script&lang=js"
export * from "./MainLedgerAccountCard.vue?vue&type=script&lang=js"
import style0 from "./MainLedgerAccountCard.vue?vue&type=style&index=0&id=3b912034&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b912034",
  null
  
)

export default component.exports